export const createAnimationFrame = (emitNotSupportedError, window, wrapSubscribeFunction) => {
    return () => wrapSubscribeFunction((observer) => {
        if (window === null || window.cancelAnimationFrame === undefined || window.requestAnimationFrame === undefined) {
            return emitNotSupportedError(observer);
        }
        let animationFrameHandle = window.requestAnimationFrame(function animationFrameCallback(timestamp) {
            animationFrameHandle = window.requestAnimationFrame(animationFrameCallback);
            observer.next(timestamp);
        });
        return () => window.cancelAnimationFrame(animationFrameHandle);
    });
};
//# sourceMappingURL=animation-frame.js.map